// Which payment gateway the top-up flow uses, and how a Toman price maps onto
// each gateway's wire unit.
//
// THE WHOLE UI PRICES IN TOMAN. The gateways disagree about what they settle
// in — Sepehr (بانک صادرات / شاپرک) takes RIALS, Zarinpal takes Toman — and
// `topUpWallet(gateway, amount)` takes the amount in THE GATEWAY'S OWN WIRE
// UNIT. So the conversion happens once, here, at the moment an amount is handed
// to the BFF.
//
// The mismatch is SILENT in the direction that costs money: sending a Toman
// figure to Sepehr undercharges by 10× and the payment succeeds. Nothing errors,
// the student is credited, and the difference is only visible in a reconciliation
// nobody runs. That is the entire reason this file exists rather than a literal
// at the call site.
//
// Copied in shape from doctor-app/parsina.client.web/src/constants/paymentGateway.js
// so the two apps cannot disagree about a bank's unit.

// The gateway table is DATA — `rialsPerToman` decides what a payment is worth,
// and `toGatewayAmount` must not need a translator to compute it. Only the
// bank's display name is copy, so only that is a key.
export const GATEWAYS = {
  sepehr:   { labelKey: 'credits.gateway.saderat',  unit: 'IRR', rialsPerToman: 10 },
  zarinpal: { labelKey: 'credits.gateway.zarinpal', unit: 'IRT', rialsPerToman: 1  },
};

/** Active gateway for new top-ups. The same one the doctor panel uses. */
export const PAYMENT_GATEWAY = 'sepehr';

/**
 * Zarinpal's own floor, in ITS unit (Toman). Recorded even though it is not the
 * active gateway, because it is a property of the gateway and not of the app —
 * switching PAYMENT_GATEWAY must not require rediscovering it.
 */
export const ZARINPAL_MIN_TOMAN = 1000;

/** The gateway's name, for the pay button. */
export const gatewayLabel = (t, gateway = PAYMENT_GATEWAY) => {
  const key = GATEWAYS[gateway]?.labelKey;
  return key ? t(key) : '';
};

/** Convert a Toman price into the amount the given gateway expects. */
export function toGatewayAmount(amountToman, gateway = PAYMENT_GATEWAY) {
  const factor = GATEWAYS[gateway]?.rialsPerToman ?? 1;
  return Math.round(Number(amountToman || 0) * factor);
}
